var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7123_13399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 9C15.0815 9 14.9333 9.28162 14.9333 9.64274V16.0385C14.9333 16.3996 14.2519 17 13.8667 17H2.13333C1.6 17 1.06667 16.5 1.06311 16.0385V2.96154C1.06311 2.60042 1.74814 2 2.13333 2H10.0091C10.3943 2 10.6667 1.86112 10.6667 1.5C10.6667 1.13888 10.3943 1 10.0091 1H2.13333C0.977782 1 0 1.91667 0 3V16C0 17 1.06311 18 2.13333 18H13.8667C15.0222 18 16 17.0833 16 16V9.64274C16 9.28166 15.8519 9 15.4667 9Z",
    fill: "#373F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2794 0.72088C17.8178 0.259234 17.1918 -6.51633e-05 16.539 1.01705e-05C15.8858 -0.00187318 15.2591 0.257878 14.7988 0.721294L6.33115 9.18821C6.2609 9.25899 6.20791 9.34502 6.17623 9.43957L4.89054 13.2967C4.77834 13.6335 4.96045 13.9975 5.29731 14.1097C5.36266 14.1315 5.4311 14.1426 5.49996 14.1427C5.56896 14.1425 5.63756 14.1315 5.7031 14.1099L9.56019 12.8242C9.65492 12.7926 9.74099 12.7393 9.81154 12.6686L18.2791 4.20104C19.2402 3.24008 19.2403 1.68195 18.2794 0.72088ZM17.5 3.5L9 12L6 13L7 10L15.5 1.5C16.259 0.721294 17.0413 1.04039 17.5 1.5C17.7191 1.71956 17.9991 2.18981 18 2.5C18.0008 2.81184 17.7209 3.27987 17.5 3.5Z",
    fill: "#373F41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7123_13399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.abc5e17ccae95827b18fd378e0ebe68a.svg";
export { ForwardRef as ReactComponent };